export default {
    apiGateway: {
        REGION: "eu-west-1",
        URL: "https://rnyj8hlnvh.execute-api.eu-west-1.amazonaws.com/prod"
    }
}